import { useEffect } from 'react';
import { supabase } from '../lib/supabase';

export function useRealtimeSignal(onSignal: () => void, meetingId?: string) {
  useEffect(() => {
    let active = true;
    const filter = meetingId
      ? { event: 'UPDATE' as const, schema: 'public', table: 'projector_signals', filter: `meeting_id=eq.${meetingId}` }
      : { event: 'UPDATE' as const, schema: 'public', table: 'projector_signals' };

    const channel = supabase
      .channel(`signals:${meetingId ?? 'all'}:${crypto.randomUUID()}`)
      .on('postgres_changes', filter, () => {
        if (active) onSignal();
      })
      .subscribe();

    return () => {
      active = false;
      void supabase.removeChannel(channel);
    };
  }, [meetingId, onSignal]);
}
